import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name:'notificationTypePipe'
})
 export class NotitificationTypePipe implements PipeTransform{

    transform(type:number){

        switch (type) {
            case 0:
                return 'type 0'
                break;
        
            case 1:
                return 'type 1'
                break;
        
            case 2:
                return 'type 2'
                
                break;
        
            case 3:
                return 'type 3'
                break;
        
            default:
                return 'unknown type'
        }
    }
 }

 /* TODO: change these strings once you find what they correspond to */